/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Blank_TitleInputs */

const en_us2_workout_blank_title = /** @type {(inputs: Workout_Blank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free workout`)
};

const pt_br2_workout_blank_title = /** @type {(inputs: Workout_Blank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino livre`)
};

const es_419_workout_blank_title = /** @type {(inputs: Workout_Blank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento libre`)
};

const pt_pt2_workout_blank_title = /** @type {(inputs: Workout_Blank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino livre`)
};

const fr_fr2_workout_blank_title = /** @type {(inputs: Workout_Blank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance libre`)
};

const de_de2_workout_blank_title = /** @type {(inputs: Workout_Blank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freies Training`)
};

const it_it2_workout_blank_title = /** @type {(inputs: Workout_Blank_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento libero`)
};

/**
* | output |
* | --- |
* | "Free workout" |
*
* @param {Workout_Blank_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_blank_title = /** @type {((inputs?: Workout_Blank_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Blank_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_blank_title(inputs)
	if (locale === "es-419") return es_419_workout_blank_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_blank_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_blank_title(inputs)
	if (locale === "de-DE") return de_de2_workout_blank_title(inputs)
	if (locale === "it-IT") return it_it2_workout_blank_title(inputs)
	return en_us2_workout_blank_title(inputs)
});
export { workout_blank_title as "workout.blank_title" }